// 共通設定。CRA/Next両対応の環境変数解決
// BACKEND_URL はホストのルート（例: http://localhost:8000 や https://api.example.com）を想定
// API_BASE は必ず "/api" を指すように補正する
export const BACKEND_URL =
  process.env.REACT_APP_BACKEND_URL ||
  process.env.NEXT_PUBLIC_BACKEND_URL ||
  'http://localhost:8080';

// API_BASE の明示指定がある場合はそれを最優先（本番でも必ず尊重）
const EXPLICIT_API_BASE =
  process.env.REACT_APP_API_BASE ||
  process.env.NEXT_PUBLIC_API_BASE ||
  '';

// 同一オリジンを基本とする（Vercelのroutesで /api -> Railway へプロキシ）
const FORCE_SAME_ORIGIN = true;

let computedApiBase = null;
const hasWindow = typeof window !== 'undefined' && window.location && window.location.origin;
const isLocalhost = hasWindow && /^(localhost|127\.0\.0\.1)/.test(window.location.hostname);

// 1) 明示指定があれば常にそれを使用
if (EXPLICIT_API_BASE) {
  computedApiBase = EXPLICIT_API_BASE;
  // 2) 明示指定がなければ、同一オリジンを優先（Vercel の routes 前提）
} else if (hasWindow) {
  // Reverted to Auto-Detect for Production Readiness
  computedApiBase = `${window.location.origin.replace(/\/$/, '')}/api`;
  // 3) SSRやwindow非存在時は BACKEND_URL をベースに /api を補完
} else {
  if (hasWindow && !EXPLICIT_API_BASE) {
    computedApiBase = `${window.location.origin.replace(/\/$/, '')}/api`;
  } else {
    computedApiBase = BACKEND_URL.endsWith('/api')
      ? BACKEND_URL
      : `${BACKEND_URL.replace(/\/$/, '')}/api`;
  }
}

// Respect local backend default port 8000 (no forced replacement)

// 明示指定がある場合のみ上書き。通常は同一オリジンの /api を使用する。

export const API_BASE = computedApiBase;

export default {
  BACKEND_URL,
  API_BASE,
};
